import { IAppState } from '../../common/state';
import { TNewbuildingBrokerFlow } from '../../types/newbuildingBroker';

export const getPageBrokerFlow = (state: IAppState): TNewbuildingBrokerFlow | undefined =>
  state.results?.newbuildingBroker?.availableBrokerFlow || undefined;
